export const onMapboxReady = (map, callback) => {
  // we have to use the internal, non-public _loaded member here in order for
  // this thing to behave properly, otherwise there's a chance that map.loaded()
  // returns false, but the `load` event never fires because this internal flag
  // is already true.
  //
  // read up on https://github.com/mapbox/mapbox-gl-js/issues/6707
  // for a full explanation of this massive footgun
  if (map._loaded) {
    callback();
  } else {
    map.once("load", callback);
  }
};
